<template>
  <e-table
    ref="table"
    name="order-stack"
    :items="items"
    :rowClass="rowClass"
    :coreColumnDefs="columnDefs"
    :columnOptions="{
      selector,
      opsDisplay: orderStackOpsDisplay,
    }"
    :defaultSort="{}"
    :getHeight="getHeight"
    @loadMore="$emit('loadMore')"
  />
</template>
<script>
import Vue from "vue";

Vue.component("order-stack-id", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div v-if="isAdmin" class="flex items-center gap-0.5">
        <check-marker :key="prefixKey('marker', item.id)" :item="{id: item.id, marker: item.marker, target: 'order'}" :size="14"/>
        <el-dropdown class="w-18">
          <span class="el-dropdown-link">          
            <popup className="text-sm no-underline" :name="item.id.toString()" componentPath="components/html" width="900px" :pivot-y=0 :options="viewOrderOptions(item.id)"/>
            <i class="el-icon-arrow-down el-icon--right text-2xs"/>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-edit-outline">
              <popup name="Edit Order" className="" componentPath="components/html" width="900px" :pivot-y=0 :options="editOrderOptions(item.id)"/>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <popup v-else :name="item.id.toString()" className="" componentPath="components/html" width="900px" :pivot-y=0 :options="viewOrderOptions(item.id)"/>          
      <div class="flex items-center justify-start gap-1 pt-0.5" v-if="isAdmin">        
        <note-entry :options="{name: item.container_no, id: item.id, type: 'Container', category: 'admin', noted: item.admin_noted }" :size="18" :key="prefixKey('notes', item.id)"/>
        <container-lock :item="item" :size="18" @reloadOrder="reloadOrder"/>
        <a class="el-icon-share text-base" :class="{gray: !item.selected, green: item.selected}" @click="select" />   
        <slot v-if="!item.operated">
          <a class="relative" v-if="item.trash" @click="toDelete">
            <i class="el-icon-delete text-base red"/>
            <span class="animate-ping absolute inline-flex top-1 left-1 h-2 w-2 rounded-full bg-red-400 opacity-75"></span>          
          </a>
          <a class="el-icon-delete text-base gray" v-else @click="toDelete" />        
        </slot>
      </div>
    </div>
  `,
  methods: {
    reloadOrder() {
      window.dispatchEvent(
        new CustomEvent("ReloadOrder", { detail: this.item.id }),
      );
    },
    select() {
      const selected = !this.item.selected;
      if (selected) {
        this.$http
          .get("/api/v1/container_selectors/new", {
            params: { id: this.item.id },
          })
          .then((response) => {
            window.dispatchEvent(
              new CustomEvent("ContainerSelector", { detail: {} }),
            );
          })
          .catch((err) => {});
      } else {
        this.$http
          .delete(`/api/v1/container_selectors/${this.item.id}`)
          .then((response) => {
            window.dispatchEvent(
              new CustomEvent("ContainerSelector", { detail: {} }),
            );
          })
          .catch((err) => {});
      }
    },
    toDelete() {
      this.$set(this.item, "trash", !this.item.trash);
    },
  },
});
Vue.component("order-stack-warehouse-name", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div class="cname" v-for="(warehouse, index) in item.warehouses" :key="index">
        {{warehouse.name}}
      </div>
    </div>
  `,
});

Vue.component("order-stack-warehouse-city", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div class="cname" v-for="(warehouse, index) in item.warehouses" :key="index">
        {{warehouse.city}}
      </div>
    </div>
  `,
});

Vue.component("order-stack-warehouse-state", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div class="cname" v-for="(warehouse, index) in item.warehouses" :key="index">
        {{warehouse.state}}
      </div>
    </div>
  `,
});

Vue.component("order-stack-cont-no", {
  props: { item: Object, options: Object },
  template: `
  <div>
      <alter-request :requester="{id: item.id, type: 'Container', attr: 'container_no'}">
        {{item.container_no}}
      </alter-request> 
      <slot v-for="o in item.transports.map(t=>t.operations).flat().filter(o=>o.mode)">
        <alter-request :requester="{id: o.id, type: 'Operation', attr: 'container_no'}" :key="o.id">
          <div class="tag">{{o.container_no}}</div>
        </alter-request>
      </slot>
    </div>
  `,
});

Vue.component("order-stack-chassis-no", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <alter-request :requester="{id: item.id, type: 'Container', attr: 'chassis_no'}">
        {{item.chassis_no}}
      </alter-request>
      <slot v-for="o in item.transports.map(t=>t.operations).flat().filter(o=>o.mode)">
        <alter-request :requester="{id: o.id, type: 'Operation', attr: 'chassis_no'}" :key="o.id">
          <div class="tag">{{o.chassis_no}}</div>
        </alter-request>
      </slot>
    </div>
  `,
});

Vue.component("order-stack-terminals", {
  props: { item: Object, options: Object },
  template: `
    <div class="">
      <div class="cname" v-for="(terminal, index) in item.terminals" :key="index">
        {{terminal.name}}
      </div>
    </div>
  `,
});

Vue.component("order-stack-triaxle", {
  props: { item: Object, options: Object },
  template: `
    <i class="el-icon-success green fs16"  v-if="item.triaxle"/>
  `,
});

Vue.component("order-stack-operations", {
  props: { item: Object, options: Object },
  template: `
    <div class="flex flex-col gap-0.5">
      <slot v-for="transport in item.transports">
        <container-transport 
          v-if="isAdmin"
          source='order-stack'
          :detail="options.opsDisplay"
          :item=transport
          :locked="item.locked"
          :key="transport.key"
          @reloadOrder="reloadOrder"
        />
        <container-transport-viewer
          v-else          
          :item=transport
          :key="transport.key"
        />        
      </slot>
    </div>
  `,
  methods: {
    reloadOrder() {
      window.dispatchEvent(
        new CustomEvent("ReloadOrder", { detail: this.item.id }),
      );
    },
  },
});

Vue.component("order-stack-appt", {
  props: { item: Object, options: Object },
  template: `
    <div v-html="item.appointment"/>
  `,
});

Vue.component("order-stack-receivable-invoices", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div v-for="invoice in item.receivable.invoices" :key="invoice.id">
        <a @click="openUrl('/invoices/' + invoice.id)">{{invoice.number}}</a>
      </div>
    </div>
  `,
});

Vue.component("order-stack-receivable-amount", {
  props: { item: Object, options: Object },
  template: `
    <popup v-if="item.receivable.charges.count > 0"
      className="green" componentPath="components/html" width="800px" height="auto"
      :options="{ title: 'Container: ' + item.id, url: '/containers/' + item.id + '/receivable_charges'}">
      <span>{{item.receivable.charges.amount | toCurrency}}</span>
      ({{item.receivable.charges.count}})
    </popup>      
  `,
});

Vue.component("order-stack-receivable-payments", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div v-for="payment in item.receivable.payments" :key="payment.id">
        <a @click="openUrl('/payments/' + payment.id)">{{payment.number}}</a>
      </div>
    </div>
  `,
});

Vue.component("order-stack-payable-invoices", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div v-for="invoice in item.payable.invoices" :key="invoice.id">
        <a @click="openUrl('/invoices/' + invoice.id)">{{invoice.number}}</a>
      </div>
    </div>
  `,
});

Vue.component("order-stack-payable-amount", {
  props: { item: Object, options: Object },
  template: `
    <popup v-if="item.payable.charges.count > 0" 
      className="red" componentPath="components/html" width="800px" height="auto"
      :options="{ title: 'Container: ' + item.id, url: '/containers/' + item.id + '/payable_charges'}">
      <span>{{item.payable.charges.amount | toCurrency}}</span>
      ({{item.payable.charges.count}})
    </popup>      
  `,
});

Vue.component("order-stack-payable-payments", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <div v-for="payment in item.payable.payments" :key="payment.id">
        <a @click="openUrl('/payments/' + payment.id)">{{payment.number}}</a>
      </div>
    </div>
  `,
});

import api from "@/default/utils/api";
export default {
  name: "ContainerOrderStackTable",
  mixins: [api],
  props: {
    items: {
      type: Array,
      required: true,
    },
    selector: {
      type: Boolean,
      default: true,
    },
    financials: {
      type: Boolean,
      default: true,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      height: 0,
      coreColumnDefs: [
        {
          title: "ID",
          field: "id",
          width: 96,
          minWidth: 96,
          fixed: "left",
          component: "order-stack-id",
        },
        {
          title: "Type",
          field: "abbrev_type",
          width: 50,
          component: "v-table-column",
        },
        {
          title: "Date",
          field: "created_date",
          width: 65,
          component: "v-table-column",
        },
        {
          title: "Warehouse",
          field: "warehouses[0].name",
          width: 180,
          aliasName: "Warehouse Name",
          component: "order-stack-warehouse-name",
        },
        {
          title: "City",
          field: "warehouses[0].city",
          width: 80,
          aliasName: "Warehouse City",
          component: "order-stack-warehouse-city",
        },
        {
          title: "State",
          field: "warehouses[0].state",
          width: 55,
          aliasName: "Warehouse State",
          component: "order-stack-warehouse-state",
        },
        {
          title: "CONT.#",
          field: "container_no",
          width: 100,
          component: "order-stack-cont-no",
        },
        {
          title: "Chassis#",
          field: "chassis_no",
          width: 100,
          component: "order-stack-chassis-no",
        },
        {
          title: "Terminals",
          field: "terminals[0].name",
          width: 100,
          component: "order-stack-terminals",
        },
        {
          title: "TRI",
          field: "triaxle",
          width: 50,
          aliasName: "Triaxle",
          component: "order-stack-triaxle",
        },
        {
          title: "Appt. Time",
          field: "appt_date",
          width: 120,
          component: "order-stack-appt",
        },
        {
          title: "LFD",
          field: "lfd",
          width: 65,
          aliasName: "Last Free Day",
          component: "v-table-column",
        },
        {
          title: "PD LFD",
          field: "per_diem_lfd",
          width: 65,
          aliasName: "Per Diem Last Free Day",
          component: "v-table-column",
        },
        {
          title: "COD",
          field: "cod",
          width: 65,
          aliasName: "Cut Off Date",
          component: "v-table-column",
        },
        {
          title: "Operations",
          field: "truckers[0].name",
          width: 320,
          component: "order-stack-operations",
        },
      ],
    };
  },
  async mounted() {
    this.initCachedColumns();
    await this.loadEnvs(this.disableColumns);
  },
  computed: {
    orderStackOpsDisplay() {
      return this.getSettings("orderStackOpsDisplay", "");
    },
    columnDefs() {
      if (this.isAdmin) {
        return [
          ...this.coreColumnDefs,
          {
            title: "Customer",
            field: "customer.name",
            width: 180,
            classes: "cell-style greenBg",
            component: "v-table-column",
          },
          {
            title: "AR INV",
            aliasName: "Receivable Invoice(s)",
            field: "receivable_invoice_numbers",
            width: 90,
            classes: "cell-style greenBg",
            component: "order-stack-receivable-invoices",
          },
          {
            title: "AR AMT",
            aliasName: "Receivable Amount",
            field: "receivable_amount",
            width: 90,
            classes: "cell-style greenBg",
            component: "order-stack-receivable-amount",
          },
          {
            title: "AR PYMT",
            aliasName: "Receivable Payment(s)",
            field: "receivable_payment_numbers",
            width: 90,
            classes: "cell-style greenBg",
            component: "order-stack-receivable-payments",
          },
          {
            title: "AP INV",
            aliasName: "Payable Invoice(s)",
            field: "payable_invoice_numbers",
            width: 90,
            classes: "cell-style pinkBg",
            component: "order-stack-payable-invoices",
          },
          {
            title: "AP AMT",
            aliasName: "Payable Amount",
            field: "payable_amount",
            width: 90,
            classes: "cell-style pinkBg",
            component: "order-stack-payable-amount",
          },
          {
            title: "AP PYMT",
            aliasName: "Payable Payment(s)",
            field: "payable_payment_numbers",
            width: 90,
            classes: "cell-style pinkBg",
            component: "order-stack-payable-payments",
          },
        ];
      }

      if (this.isCustomer) {
        return [
          ...this.coreColumnDefs,
          {
            title: "Payable Invoice(s)",
            field: "payable_invoice_numbers",
            width: 120,
            classes: "greenBg",
            component: "order-stack-receivable-invoices",
          },
          {
            title: "Payable Amount",
            field: "payable_amount",
            width: 120,
            classes: "em12 customer",
            component: "order-stack-receivable-amount",
          },
          {
            title: "Payable Payment(s)",
            field: "payable_payment_numbers",
            width: 120,
            classes: "greenBg",
            component: "order-stack-receivable-payments",
          },
        ];
      }

      if (this.isTrucker) {
        return [
          ...this.coreColumnDefs,
          {
            title: "Receivable Invoice(s)",
            field: "receivable_invoice_numbers",
            width: 120,
            classes: "pinkBg",
            component: "order-stack-payable-invoices",
          },
          {
            title: "Receivable Amount",
            field: "receivable_amount",
            width: 120,
            classes: "pinkBg",
            component: "order-stack-payable-amount",
          },
          {
            title: "Receivable Payment(s)",
            field: "receivable_payment_numbers",
            width: 120,
            classes: "pinkBg",
            component: "order-stack-payable-payments",
          },
        ];
      }
    },
  },
  methods: {
    getHeight() {
      return this.autoHeight
        ? "100%"
        : document.querySelector("#app > .content").offsetHeight - 50;
    },
    scrollTop() {
      this.$refs.table.$refs.utable.pagingScrollTopLeft(0, 0);
    },
    initCachedColumns() {
      let columns = [
        "ID",
        "Type",
        "Date",
        "Warehouse Name",
        "Warehouse City",
        "Warehouse State",
        "CONT.#",
        "Chassis#",
        "Terminals",
        "Triaxle",
        "Operations",
        "Appt. Time",
        "Last Free Day",
        "Per Diem LFD",
        "Cut Off Date",
        "Customer",
        "Receivable Invoice(s)",
        "Receivable Amount",
        "Receivable Payment(s)",
        "Payable Invoice(s)",
        "Payable Amount",
        "Payable Payment(s)",
      ];
      let trash = [];
      if (this.isCustomer) {
        trash = [
          "Lock",
          "Customer",
          "Receivable Invoice(s)",
          "Receivable Amount",
          "Receivable Payment(s)",
        ];
      }
      if (this.isTrucker) {
        trash = [
          "Lock",
          "Customer",
          "Payable Invoice(s)",
          "Payable Amount",
          "Payable Payment(s)",
        ];
        if (!this.financials) {
          trash = [
            ...trash,
            "Receivable Invoice(s)",
            "Receivable Amount",
            "Receivable Payment(s)",
          ];
        }
      }
      this.initTableColumns("order-stack", this.removeColumns(columns, trash));
      this.$emit("initColumnOptions");
    },
    disableColumns() {
      ["Payable Invoice(s)", "Payable Amount", "Payable Payment(s)"].forEach(
        (name) => {
          this.updateTableColumn("order-stack", name, {
            disabled: this.$store.envs.customer_mode,
          });
        },
      );
      [
        "Customer",
        "Receivable Invoice(s)",
        "Receivable Amount",
        "Receivable Payment(s)",
      ].forEach((name) => {
        this.updateTableColumn("order-stack", name, {
          disabled: this.$store.envs.driver_mode,
        });
      });
      this.$emit("initColumnOptions");
    },
    removeColumns(columns, toRemoveNames) {
      toRemoveNames.forEach((name) => {
        let index = columns.findIndex((o) => o == name);
        columns.splice(index, 1);
      });
      return columns;
    },
    rowClass({ row }) {
      let rowStyles = { hazmats: row.haz_cargo };
      return rowStyles;
    },
  },
};
</script>
